import Order from './Order'

const TIKTOK_CARRIER_CODES = [
  ['LaserShip'],
  ['TForce'],
  ['Deliver-it'],
  ['GLS US'],
  ['First Mile'],
  ['UPS'],
  ['OnTrac'],
  ['AxleHire'],
  ['DHL eCommerce'],
  ['USPS'],
  ['Asendia US'],
  ['Better Trucks'],
  ['Amazon Logistics'],
  ['Lone Star Overnight'],
  ['Spee-Dee Delivery'],
  ['Wizmo'],
  ['FedEx']
]

const TIKTOK_SERVICE_TYPES = {
  GA: 'USPS First-Class',
  PM: 'USPS Priority-Mail',
  GENERAL: 'USPS First-Class',
  GA_NON: 'USPS First-Class',
  PM_NON: 'USPS Priority-Mail',
  UPS_2ND_DAY_AIR: 'UPS 2nd Day Air',
  UPS_2ND_DAY_AIR_AM: 'UPS 2nd Day Air A.M.',
  UPS_NEXT_DAY_AIR: 'UPS Next Day Air',
  UPS_NEXT_DAY_AIR_SAVER: 'UPS Next Day Air Saver',
  UPS_NEXT_DAY_AIR_EARLY: 'UPS Next Day Air®Early',
  UPS_3_DAY_SELECT: 'UPS 3 Day Select',
  UPS_GROUND: 'UPS Ground',
  UPS_STANDARD: 'UPS_STANDARD',
  UPS_WORLDWIDE_EXPEDITED: 'UPS_WORLDWIDE_EXPEDITED',
  UPS_WORLDWIDE_EXPRESS: 'UPS_WORLDWIDE_EXPRESS',
  UPS_WORLDWIDE_EXPRESS_PLUS: 'UPS_WORLDWIDE_EXPRESS_PLUS',
  UPS_WORLDWIDE_SAVER: 'UPS_WORLDWIDE_SAVER',
  FEDEX_GROUND: 'FedEx Ground Economy',
  GROUND_HOME_DELIVERY: 'FedEx Home Delivery',
  FIRST_OVERNIGHT: 'FedEx First Overnight',
  PRIORITY_OVERNIGHT: 'FedEx Priority Overnight',
  FEDEX_2_DAY: 'FedEx 2Day',
  FEDEX_EXPRESS_SAVER: 'FedEx Express Saver',
  FEDEX_2_DAY_AM: 'FedEx 2Day A.M.',
  STANDARD_OVERNIGHT: 'FedEx Standard Overnight'
}

/**
 *
 * @param {string} carrierOrCarrierService
 */
function getCarrierCode (carrierOrCarrierService) {
  for (let carrierCode of TIKTOK_CARRIER_CODES) {
    if (
      carrierCode.some(
        code =>
          code.toLowerCase() === carrierOrCarrierService.trim().toLowerCase()
      )
    ) {
      return carrierCode[0]
    }
  }
  return 'Other'
}

function getServiceType (serviceType = '') {
  return TIKTOK_SERVICE_TYPES[serviceType.toUpperCase()]
}
export default class TiktokOrder extends Order {
  static fields () {
    return {
      platform: this.string('Tiktok'),
      isPrime: this.boolean(false)
    }
  }

  static getSheetName () {
    return 'Shipping info'
  }

  static fileType = 'xlsx';

  static getFileHeader () {
    return [
      'Order ID',
      'SKU ID(optional)',
      'Quantity(optional)',
      'Tracking ID',
      'Shipping Provider Name',
      'Shipping service'
    ]
  }

  getFileRows () {
    return this.shipments.map(shipment => [
      this.orderId,
      shipment.orderItemId,
      shipment.quantity,
      shipment.trackingNumber,
      getCarrierCode(shipment.carrierName || shipment.carrierCode),
      getServiceType(
        shipment.carrierName.toLowerCase() === 'usps'
          ? shipment.channel
          : shipment.carrierCode
      ) || shipment.serviceType
    ])
  }
}



// WEBPACK FOOTER //
// ./src/orm/models/Order/TiktokOrder.js